export default __webpack_public_path__ + "static/media/icon-arrow-down-white.cfb954bf.svg";